export default {
  specificOption: [
    {text: "Booking", value: "BOK", alias: "- BOOKING", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 1},
    {text: "Booking (ET)", value: "BOK ET", alias: "- BOOKING", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 2},
    {text: "Booking (ET) Over/Under", value: "BOK ET OU", alias: "- BOOKING", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 3},
    {text: "Booking Over/Under", value: "BOK OU", alias: "- BOOKING", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 4},

    {text: "Goal Kick", value: "NXT GK", alias: "- GOAL KICK", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 5},
    {text: "Goal Kick (ET)", value: "NXT GK ET", alias: "- GOAL KICK", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 6},

    {text: "Next Corner Awarded", value: "NXT CR", alias: "- CORNERS", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 7},
    {text: "Next Corner Awarded (ET)", value: "NXT CR ET", alias: "- CORNERS", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 8},
    {text: "Next Corner Awarded (ET) Over/Under", value: "NXT CR ET OU", alias: "- CORNERS", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 9},
    {text: "Next Corner Awarded Over/Under", value: "NXT CR OU", alias: "- CORNERS", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 10},

    {text: "Penalty", value: "PEN", alias: "- PENALTY", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 11},
    {text: "Penalty Shoot-Out", value: "PEN SO", alias: "- PENALTY SHOOT-OUT", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 12},

    {text: "Single Team (ET) Over/Under", value: "ST ET OU", alias: "- SINGLE TEAM OVER/UNDER", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 13},
    {text: "Single Team Over/Under", value: "ST OU", alias: "- SINGLE TEAM OVER/UNDER", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 14},
    {text: "Single Team Total Goal", value: "ST TG", alias: "- SINGLE TEAM TOTAL GOAL", sport: 1, ignoreTeam: false, includeSubMatch: true, seq: 15},

    {text: "Specials Goal", value: "NXT GL", alias: "- SPECIALS GOAL", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 16},
    {text: "Specials Goal (ET)", value: "NXT GL ET", alias: "- SPECIALS GOAL", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 17},

    {text: "Specific 15 Mins", value: "SOU 15M", alias: "- SPECIFIC 15 MINS", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 18},
    {text: "Specific 15 Mins Number Of Corners", value: "SOU 15C", alias: "- SPECIFIC 15 MINS NUMBER OF CORNERS", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 19},
    {text: "Specific 15 Mins Total Bookings", value: "BOK 15M", alias: "- SPECIFIC 15 MINS TOTAL BOOKINGS", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 20},

    {text: "Specific 10 Mins", value: "SOU 10M", alias: "- SPECIFIC 10 MINS", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 21},
    {text: "Specific 10 Mins Number Of Corners", value: "SOU 10C", alias: "- SPECIFIC 10 MINS NUMBER OF CORNERS", sport: 1, ignoreTeam: false, includeSubMatch: false, seq: 22},

    {text: "1st Quarter", value: "1ST QRT", alias: "- 1st Quarter", sport: 2, ignoreTeam: true, includeSubMatch: false, seq: 1},
    {text: "2nd Quarter", value: "2ND QRT", alias: "- 2nd Quarter", sport: 2, ignoreTeam: true, includeSubMatch: false, seq: 2},
    {text: "3rd Quarter", value: "3RD QRT", alias: "- 3rd Quarter", sport: 2, ignoreTeam: true, includeSubMatch: false, seq: 3},
    {text: "4th Quarter", value: "4TH QRT", alias: "- 4th Quarter", sport: 2, ignoreTeam: true, includeSubMatch: false, seq: 4},

    {text: "Home Team Total Points", value: "HT TP", alias: "- Home Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 5},
    {text: "Away Team Total Points", value: "AT TP", alias: "- Away Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 6},
    {text: "First Half Home Team Total Points", value: "FH HT TP", alias: "- First Half Home Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 7},
    {text: "First Half Away Team Total Points", value: "FH AT TP", alias: "- First Half Away Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 8},

    {text: "1st Quarter Home Team Total Points", value: "1ST QRT HT TP", alias: "- 1st Quarter Home Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 9},
    {text: "2nd Quarter Home Team Total Points", value: "2ND QRT HT TP", alias: "- 2nd Quarter Home Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 10},
    {text: "3rd Quarter Home Team Total Points", value: "3RD QRT HT TP", alias: "- 3rd Quarter Home Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 11},
    {text: "4th Quarter Home Team Total Points", value: "4TH QRT HT TP", alias: "- 4th Quarter Home Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 12},

    {text: "1st Quarter Away Team Total Points", value: "1ST QRT AT TP", alias: "- 1st Quarter Away Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 13},
    {text: "2nd Quarter Away Team Total Points", value: "2ND QRT AT TP", alias: "- 2nd Quarter Away Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 14},
    {text: "3rd Quarter Away Team Total Points", value: "3RD QRT AT TP", alias: "- 3rd Quarter Away Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 15},
    {text: "4th Quarter Away Team Total Points", value: "4TH QRT AT TP", alias: "- 4th Quarter Away Team Total Points", sport: 2, ignoreTeam: false, includeSubMatch: false, seq: 16},

    {text: "Next Goal", value: "NXT GL IH", alias: "- NEXT GOAL", sport: 9, ignoreTeam: false, includeSubMatch: false, seq: 1}
  ],
  specificList: {
    "NXT CR": {
      preferLeague: " - CORNERS",
      sboLeague: " - CORNERS",
      ibcLeague: " - CORNERS",
      style: 1,
      teamOpt: [
        { name: "No.of Corners", val: 0 }, { name: "1st Corner", val: 1 }, { name: "2nd Corner", val: 2 },
        { name: "3rd Corner", val: 3 }, { name: "4th Corner", val: 4 }, { name: "5th Corner", val: 5 },
        { name: "6th Corner", val: 6 }, { name: "7th Corner", val: 7 }, { name: "8th Corner", val: 8 },
        { name: "9th Corner", val: 9 }, { name: "10th Corner", val: 10 }, { name: "11th Corner", val: 11 },
        { name: "12th Corner", val: 12 }, { name: "13th Corner", val: 13 }, { name: "14th Corner", val: 14 },
        { name: "15th Corner", val: 15 }, { name: "16th Corner", val: 16 }, { name: "17th Corner", val: 17 },
        { name: "18th Corner", val: 18 }, { name: "19th Corner", val: 19 }, { name: "20th Corner", val: 20 },
        { name: "21st Corner", val: 21 }, { name: "22nd Corner", val: 22 }, { name: "23rd Corner", val: 23 },
        { name: "24th Corner", val: 24 }, { name: "25th Corner", val: 25 }, { name: "26th Corner", val: 26 }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "No.of Corners", "group": "No.of Corners"}, { "special_1": "1st Corner", "group": "1st Corner"}, { "special_1": "2nd Corner", "group": "2nd Corner"},
        { "special_1": "3rd Corner", "group": "3rd Corner"}, { "special_1": "4th Corner", "group": "4th Corner"}, { "special_1": "5th Corner", "group": "5th Corner"},
        { "special_1": "6th Corner", "group": "6th Corner"}, { "special_1": "7th Corner", "group": "7th Corner"}, { "special_1": "8th Corner", "group": "8th Corner"},
        { "special_1": "9th Corner", "group": "9th Corner"}, { "special_1": "10th Corner", "group": "10th Corner"}, { "special_1": "11th Corner", "group": "11th Corner"},
        { "special_1": "12th Corner", "group": "12th Corner"}, { "special_1": "13th Corner", "group": "13th Corner"}, { "special_1": "14th Corner", "group": "14th Corner"},
        { "special_1": "15th Corner", "group": "15th Corner"}, { "special_1": "16th Corner", "group": "16th Corner"}, { "special_1": "17th Corner", "group": "17th Corner"},
        { "special_1": "18th Corner", "group": "18th Corner"}, { "special_1": "19th Corner", "group": "19th Corner"}, { "special_1": "20th Corner", "group": "20th Corner"},
        { "special_1": "21st Corner", "group": "21st Corner"}, { "special_1": "22nd Corner", "group": "22nd Corner"}, { "special_1": "23rd Corner", "group": "23rd Corner"},
        { "special_1": "24th Corner", "group": "24th Corner"}, { "special_1": "25th Corner", "group": "25th Corner"}, { "special_1": "26th Corner", "group": "26th Corner"}
      ],
    },
    "NXT CR ET": {
      preferLeague: " - CORNERS",
      sboLeague: " - CORNERS",
      ibcLeague: " - CORNERS",
      style: 1,
      teamOpt: [
        { name: "No.of Corners", val: 0 }, { name: "1st Corner", val: 1 }, { name: "2nd Corner", val: 2 },
        { name: "3rd Corner", val: 3 }, { name: "4th Corner", val: 4 }, { name: "5th Corner", val: 5 },
        { name: "6th Corner", val: 6 }, { name: "7th Corner", val: 7 }, { name: "8th Corner", val: 8 },
        { name: "9th Corner", val: 9 }, { name: "10th Corner", val: 10 }, { name: "11th Corner", val: 11 },
        { name: "12th Corner", val: 12 }, { name: "13th Corner", val: 13 }, { name: "14th Corner", val: 14 },
        { name: "15th Corner", val: 15 }, { name: "16th Corner", val: 16 }, { name: "17th Corner", val: 17 },
        { name: "18th Corner", val: 18 }, { name: "19th Corner", val: 19 }, { name: "20th Corner", val: 20 },
        { name: "21st Corner", val: 21 }, { name: "22nd Corner", val: 22 }, { name: "23rd Corner", val: 23 },
        { name: "24th Corner", val: 24 }, { name: "25th Corner", val: 25 }, { name: "26th Corner", val: 26 }
      ],
      preferTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      sboTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1} (ET)", "away": "{away_team} {special_1} (ET)" }],
      team: [
        { "special_1": "No.of Corners", "group": "No.of Corners"}, { "special_1": "1st Corner", "group": "1st Corner"}, { "special_1": "2nd Corner", "group": "2nd Corner"},
        { "special_1": "3rd Corner", "group": "3rd Corner"}, { "special_1": "4th Corner", "group": "4th Corner"}, { "special_1": "5th Corner", "group": "5th Corner"},
        { "special_1": "6th Corner", "group": "6th Corner"}, { "special_1": "7th Corner", "group": "7th Corner"}, { "special_1": "8th Corner", "group": "8th Corner"},
        { "special_1": "9th Corner", "group": "9th Corner"}, { "special_1": "10th Corner", "group": "10th Corner"}, { "special_1": "11th Corner", "group": "11th Corner"},
        { "special_1": "12th Corner", "group": "12th Corner"}, { "special_1": "13th Corner", "group": "13th Corner"}, { "special_1": "14th Corner", "group": "14th Corner"},
        { "special_1": "15th Corner", "group": "15th Corner"}, { "special_1": "16th Corner", "group": "16th Corner"}, { "special_1": "17th Corner", "group": "17th Corner"},
        { "special_1": "18th Corner", "group": "18th Corner"}, { "special_1": "19th Corner", "group": "19th Corner"}, { "special_1": "20th Corner", "group": "20th Corner"},
        { "special_1": "21st Corner", "group": "21st Corner"}, { "special_1": "22nd Corner", "group": "22nd Corner"}, { "special_1": "23rd Corner", "group": "23rd Corner"},
        { "special_1": "24th Corner", "group": "24th Corner"}, { "special_1": "25th Corner", "group": "25th Corner"}, { "special_1": "26th Corner", "group": "26th Corner"}
      ],
    },
    "NXT CR OU": {
      preferLeague: " - CORNERS",
      sboLeague: " - CORNERS",
      ibcLeague: " - CORNERS",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} No.of Corners - Over", "special_2": "{home_team} No.of Corners - Under", "group": "Home (Over & Under)"},
        { "special_1": "{away_team} No.of Corners - Over", "special_2": "{away_team} No.of Corners - Under", "group": "Away (Over & Under)"},
      ]
    },
    "NXT CR ET OU": {
      preferLeague: " - CORNERS",
      sboLeague: " - CORNERS",
      ibcLeague: " - CORNERS",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} (ET) No.of Corners - Over", "special_2": "{home_team} (ET) No.of Corners - Under", "group": "Home (Over & Under)"},
        { "special_1": "{away_team} (ET) No.of Corners - Over", "special_2": "{away_team} (ET) No.of Corners - Under", "group": "Away (Over & Under)"},
      ]
    },
    "SOU 15M": {
      preferLeague: " - SPECIFIC 15 MINS",
      sboLeague: " - SPECIFIC 15 MINS",
      ibcLeague: " - SPECIFIC 15 MINS",
      style: 1,
      teamOpt: [
        { name: "00:00-15:00" }, { name: "15:01-30:00" },
        { name: "30:01-45:00" }, { name: "45:01-60:00" }, { name: "60:01-75:00" },
        { name: "75:01-90:00" }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "00:00-15:00", "group": "00:00-15:00"}, { "special_1": "15:01-30:00", "group": "15:01-30:00"}, { "special_1": "30:01-45:00", "group": "30:01-45:00"},
        { "special_1": "45:01-60:00", "group": "45:01-60:00"}, { "special_1": "60:01-75:00", "group": "60:01-75:00"}, { "special_1": "75:01-90:00", "group": "75:01-90:00"}
      ],
    },
    "SOU 10M": {
      preferLeague: " - SPECIFIC 10 MINS",
      sboLeague: " - SPECIFIC 10 MINS",
      ibcLeague: " - SPECIFIC 10 MINS",
      style: 1,
      teamOpt: [
        { name: "00:00-10:00" }, { name: "10:01-20:00" }, { name: "20:01-30:00" },
        { name: "30:01-40:00" }, { name: "40:01-50:00" }, { name: "50:01-60:00" },
        { name: "60:01-70:00" }, { name: "70:01-80:00" }, { name: "80:01-90:00" }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "00:00-10:00", "group": "00:00-10:00"}, { "special_1": "10:01-20:00", "group": "10:01-20:00"}, { "special_1": "20:01-30:00", "group": "20:01-30:00"},
        { "special_1": "30:01-40:00", "group": "30:01-40:00"}, { "special_1": "40:01-50:00", "group": "40:01-50:00"}, { "special_1": "50:01-60:00", "group": "50:01-60:00"},
        { "special_1": "60:01-70:00", "group": "60:01-70:00"}, { "special_1": "70:01-80:00", "group": "70:01-80:00"}, { "special_1": "80:01-90:00", "group": "80:01-90:00"}
      ],
    },
    "BOK": {
      preferLeague: " - BOOKING",
      sboLeague: " - BOOKING",
      ibcLeague: " - BOOKING",
      style: 1,
      teamOpt: [
        { name: "Total Bookings", val: 0 }, { name: "1st Booking", val: 1 }, { name: "2nd Booking", val: 2 },
        { name: "3rd Booking", val: 3 }, { name: "4th Booking", val: 4 }, { name: "5th Booking", val: 5 },
        { name: "6th Booking", val: 6 }, { name: "7th Booking", val: 7 }, { name: "8th Booking", val: 8 },
        { name: "9th Booking", val: 9 }, { name: "10th Booking", val: 10 }, { name: "11th Booking", val: 11 },
        { name: "12th Booking", val: 12 }, { name: "13th Booking", val: 13 }, { name: "14th Booking", val: 14 },
        { name: "15th Booking", val: 15 }, { name: "16th Booking", val: 16 }, { name: "17th Booking", val: 17 },
        { name: "18th Booking", val: 18 }, { name: "19th Booking", val: 19 }, { name: "20th Booking", val: 20 },
        { name: "21st Booking", val: 21 }, { name: "22nd Booking", val: 22 }, { name: "23rd Booking", val: 23 },
        { name: "24th Booking", val: 24 }, { name: "25th Booking", val: 25 }, { name: "26th Booking", val: 26 }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "Total Bookings", "group": "Total Bookings"}, { "special_1": "1st Booking", "group": "1st Booking"}, { "special_1": "2nd Booking", "group": "2nd Booking"},
        { "special_1": "3rd Booking", "group": "3rd Booking"}, { "special_1": "4th Booking", "group": "4th Booking"}, { "special_1": "5th Booking", "group": "5th Booking"},
        { "special_1": "6th Booking", "group": "6th Booking"}, { "special_1": "7th Booking", "group": "7th Booking"}, { "special_1": "8th Booking", "group": "8th Booking"},
        { "special_1": "9th Booking", "group": "9th Booking"}, { "special_1": "10th Booking", "group": "10th Booking"}, { "special_1": "11th Booking", "group": "11th Booking"},
        { "special_1": "12th Booking", "group": "12th Booking"}, { "special_1": "13th Booking", "group": "13th Booking"}, { "special_1": "14th Booking", "group": "14th Booking"},
        { "special_1": "15th Booking", "group": "15th Booking"}, { "special_1": "16th Booking", "group": "16th Booking"}, { "special_1": "17th Booking", "group": "17th Booking"},
        { "special_1": "18th Booking", "group": "18th Booking"}, { "special_1": "19th Booking", "group": "19th Booking"}, { "special_1": "20th Booking", "group": "20th Booking"},
        { "special_1": "21st Booking", "group": "21st Booking"}, { "special_1": "22nd Booking", "group": "22nd Booking"}, { "special_1": "23rd Booking", "group": "23rd Booking"},
        { "special_1": "24th Booking", "group": "24th Booking"}, { "special_1": "25th Booking", "group": "25th Booking"}, { "special_1": "26th Booking", "group": "26th Booking"}
      ],
    },
    "BOK ET": {
      preferLeague: " - BOOKING",
      sboLeague: " - BOOKING",
      ibcLeague: " - BOOKING",
      style: 1,
      teamOpt: [
        { name: "Total Bookings", val: 0 }, { name: "1st Booking", val: 1 }, { name: "2nd Booking", val: 2 },
        { name: "3rd Booking", val: 3 }, { name: "4th Booking", val: 4 }, { name: "5th Booking", val: 5 },
        { name: "6th Booking", val: 6 }, { name: "7th Booking", val: 7 }, { name: "8th Booking", val: 8 },
        { name: "9th Booking", val: 9 }, { name: "10th Booking", val: 10 }, { name: "11th Booking", val: 11 },
        { name: "12th Booking", val: 12 }, { name: "13th Booking", val: 13 }, { name: "14th Booking", val: 14 },
        { name: "15th Booking", val: 15 }, { name: "16th Booking", val: 16 }, { name: "17th Booking", val: 17 },
        { name: "18th Booking", val: 18 }, { name: "19th Booking", val: 19 }, { name: "20th Booking", val: 20 },
        { name: "21st Booking", val: 21 }, { name: "22nd Booking", val: 22 }, { name: "23rd Booking", val: 23 },
        { name: "24th Booking", val: 24 }, { name: "25th Booking", val: 25 }, { name: "26th Booking", val: 26 }
      ],
      preferTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      sboTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1} (ET)", "away": "{away_team} {special_1} (ET)" }],
      team: [
        { "special_1": "Total Bookings", "group": "Total Bookings"}, { "special_1": "1st Booking", "group": "1st Booking"}, { "special_1": "2nd Booking", "group": "2nd Booking"},
        { "special_1": "3rd Booking", "group": "3rd Booking"}, { "special_1": "4th Booking", "group": "4th Booking"}, { "special_1": "5th Booking", "group": "5th Booking"},
        { "special_1": "6th Booking", "group": "6th Booking"}, { "special_1": "7th Booking", "group": "7th Booking"}, { "special_1": "8th Booking", "group": "8th Booking"},
        { "special_1": "9th Booking", "group": "9th Booking"}, { "special_1": "10th Booking", "group": "10th Booking"}, { "special_1": "11th Booking", "group": "11th Booking"},
        { "special_1": "12th Booking", "group": "12th Booking"}, { "special_1": "13th Booking", "group": "13th Booking"}, { "special_1": "14th Booking", "group": "14th Booking"},
        { "special_1": "15th Booking", "group": "15th Booking"}, { "special_1": "16th Booking", "group": "16th Booking"}, { "special_1": "17th Booking", "group": "17th Booking"},
        { "special_1": "18th Booking", "group": "18th Booking"}, { "special_1": "19th Booking", "group": "19th Booking"}, { "special_1": "20th Booking", "group": "20th Booking"},
        { "special_1": "21st Booking", "group": "21st Booking"}, { "special_1": "22nd Booking", "group": "22nd Booking"}, { "special_1": "23rd Booking", "group": "23rd Booking"},
        { "special_1": "24th Booking", "group": "24th Booking"}, { "special_1": "25th Booking", "group": "25th Booking"}, { "special_1": "26th Booking", "group": "26th Booking"}
      ],
    },
    "BOK OU": {
      preferLeague: " - BOOKING",
      sboLeague: " - BOOKING",
      ibcLeague: " - BOOKING",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} Total Bookings - Over", "special_2": "{home_team} Total Bookings - Under", "group": "Home (Over & Under)"},
        { "special_1": "{away_team} Total Bookings - Over", "special_2": "{away_team} Total Bookings - Under", "group": "Away (Over & Under)"},
      ]
    },
    "BOK ET OU": {
      preferLeague: " - BOOKING",
      sboLeague: " - BOOKING",
      ibcLeague: " - BOOKING",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} (ET) Total Bookings - Over", "special_2": "{home_team} (ET) Total Bookings - Under", "group": "Home (Over & Under)"},
        { "special_1": "{away_team} (ET) Total Bookings - Over", "special_2": "{away_team} (ET) Total Bookings - Under", "group": "Away (Over & Under)"},
      ]
    },
    "BOK 15M": {
      preferLeague: " - SPECIFIC 15 MINS TOTAL BOOKINGS",
      sboLeague: " - SPECIFIC 15 MINS TOTAL BOOKINGS",
      ibcLeague: " - SPECIFIC 15 MINS TOTAL BOOKINGS",
      style: 1,
      teamOpt: [
        { name: "Total Bookings 00:00-15:00" }, { name: "Total Bookings 15:01-30:00" }, { name: "Total Bookings 30:01-45:00" },
        { name: "Total Bookings 45:01-60:00" }, { name: "Total Bookings 60:01-75:00" }, { name: "Total Bookings 75:01-90:00" },
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "Total Bookings 00:00-15:00", "group": "Total Bookings 00:00-15:00"}, { "special_1": "Total Bookings 15:01-30:00", "group": "Total Bookings 15:01-30:00"},
        { "special_1": "Total Bookings 30:01-45:00", "group": "Total Bookings 30:01-45:00"}, { "special_1": "Total Bookings 45:01-60:00", "group": "Total Bookings 45:01-60:00"},
        { "special_1": "Total Bookings 60:01-75:00", "group": "Total Bookings 60:01-75:00"}, { "special_1": "Total Bookings 75:01-90:00", "group": "Total Bookings 75:01-90:00"}
      ],
    },
    "SOU 15C": {
      preferLeague: " - SPECIFIC 15 MINS NUMBER OF CORNERS",
      sboLeague: " - SPECIFIC 15 MINS NUMBER OF CORNERS",
      ibcLeague: " - SPECIFIC 15 MINS NUMBER OF CORNERS",
      style: 1,
      teamOpt: [
        { name: "No.of Corners 00:00-15:00" }, { name: "No.of Corners 15:01-30:00" }, { name: "No.of Corners 30:01-45:00" },
        { name: "No.of Corners 45:01-60:00" }, { name: "No.of Corners 60:01-75:00" }, { name: "No.of Corners 75:01-90:00" },
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "No.of Corners 00:00-15:00", "group": "No.of Corners 00:00-15:00"}, { "special_1": "No.of Corners 15:01-30:00", "group": "No.of Corners 15:01-30:00"},
        { "special_1": "No.of Corners 30:01-45:00", "group": "No.of Corners 30:01-45:00"}, { "special_1": "No.of Corners 45:01-60:00", "group": "No.of Corners 45:01-60:00"},
        { "special_1": "No.of Corners 60:01-75:00", "group": "No.of Corners 60:01-75:00"}, { "special_1": "No.of Corners 75:01-90:00", "group": "No.of Corners 75:01-90:00"}
      ],
    },
    "SOU 10C": {
      preferLeague: " - SPECIFIC 10 MINS NUMBER OF CORNERS",
      sboLeague: " - SPECIFIC 10 MINS NUMBER OF CORNERS",
      ibcLeague: " - SPECIFIC 10 MINS NUMBER OF CORNERS",
      style: 1,
      teamOpt: [
        { name: "No.of Corners 00:00-10:00" }, { name: "No.of Corners 10:01-20:00" }, { name: "No.of Corners 20:01-30:00" },
        { name: "No.of Corners 30:01-40:00" }, { name: "No.of Corners 40:01-50:00" }, { name: "No.of Corners 50:01-60:00" },
        { name: "No.of Corners 60:01-70:00" }, { name: "No.of Corners 70:01-80:00" }, { name: "No.of Corners 80:01-90:00" }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "No.of Corners 00:00-10:00", "group": "No.of Corners 00:00-10:00"}, { "special_1": "No.of Corners 10:01-20:00", "group": "No.of Corners 10:01-20:00"}, { "special_1": "No.of Corners 20:01-30:00", "group": "No.of Corners 20:01-30:00"},
        { "special_1": "No.of Corners 30:01-40:00", "group": "No.of Corners 30:01-40:00"}, { "special_1": "No.of Corners 40:01-50:00", "group": "No.of Corners 40:01-50:00"}, { "special_1": "No.of Corners 50:01-60:00", "group": "No.of Corners 50:01-60:00"},
        { "special_1": "No.of Corners 60:01-70:00", "group": "No.of Corners 60:01-70:00"}, { "special_1": "No.of Corners 70:01-80:00", "group": "No.of Corners 70:01-80:00"}, { "special_1": "No.of Corners 80:01-90:00", "group": "No.of Corners 80:01-90:00"},
      ],
    },
    "NXT GL": {
      preferLeague: " - SPECIALS GOAL",
      sboLeague: " - SPECIALS GOAL",
      ibcLeague: " - SPECIALS GOAL",
      style: 1,
      teamOpt: [
        { name: "1st Goal", val: 1 }, { name: "2nd Goal", val: 2 },
        { name: "3rd Goal", val: 3 }, { name: "4th Goal", val: 4 }, { name: "5th Goal", val: 5 },
        { name: "6th Goal", val: 6 }, { name: "7th Goal", val: 7 }, { name: "8th Goal", val: 8 },
        { name: "9th Goal", val: 9 }, { name: "10th Goal", val: 10 }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "1st Goal", "group": "1st Goal"}, { "special_1": "2nd Goal", "group": "2nd Goal"},
        { "special_1": "3rd Goal", "group": "3rd Goal"}, { "special_1": "4th Goal", "group": "4th Goal"}, { "special_1": "5th Goal", "group": "5th Goal"},
        { "special_1": "6th Goal", "group": "6th Goal"}, { "special_1": "7th Goal", "group": "7th Goal"}, { "special_1": "8th Goal", "group": "8th Goal"},
        { "special_1": "9th Goal", "group": "9th Goal"}, { "special_1": "10th Goal", "group": "10th Goal"},
      ],
    },
    "NXT GL ET": {
      preferLeague: " - SPECIALS GOAL",
      sboLeague: " - SPECIALS GOAL",
      ibcLeague: " - SPECIALS GOAL",
      style: 1,
      teamOpt: [
        { name: "1st Goal", val: 1 }, { name: "2nd Goal", val: 2 },
        { name: "3rd Goal", val: 3 }, { name: "4th Goal", val: 4 }, { name: "5th Goal", val: 5 },
        { name: "6th Goal", val: 6 }, { name: "7th Goal", val: 7 }, { name: "8th Goal", val: 8 },
        { name: "9th Goal", val: 9 }, { name: "10th Goal", val: 10 }
      ],
      preferTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      sboTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1} (ET)", "away": "{away_team} {special_1} (ET)" }],
      team: [
        { "special_1": "1st Goal", "group": "1st Goal"}, { "special_1": "2nd Goal", "group": "2nd Goal"},
        { "special_1": "3rd Goal", "group": "3rd Goal"}, { "special_1": "4th Goal", "group": "4th Goal"}, { "special_1": "5th Goal", "group": "5th Goal"},
        { "special_1": "6th Goal", "group": "6th Goal"}, { "special_1": "7th Goal", "group": "7th Goal"}, { "special_1": "8th Goal", "group": "8th Goal"},
        { "special_1": "9th Goal", "group": "9th Goal"}, { "special_1": "10th Goal", "group": "10th Goal"},
      ],
    },
    "NXT GK": {
      preferLeague: " - GOAL KICK",
      sboLeague: " - GOAL KICK",
      ibcLeague: " - GOAL KICK",
      style: 1,
      teamOpt: [
        { name: "1st Goal Kick", val: 1 }, { name: "2nd Goal Kick", val: 2 },
        { name: "3rd Goal Kick", val: 3 }, { name: "4th Goal Kick", val: 4 }, { name: "5th Goal Kick", val: 5 },
        { name: "6th Goal Kick", val: 6 }, { name: "7th Goal Kick", val: 7 }, { name: "8th Goal Kick", val: 8 },
        { name: "9th Goal Kick", val: 9 }, { name: "10th Goal Kick", val: 10 }, { name: "11th Goal Kick", val: 11 },
        { name: "12th Goal Kick", val: 12 }, { name: "13th Goal Kick", val: 13 }, { name: "14th Goal Kick", val: 14 },
        { name: "15th Goal Kick", val: 15 }, { name: "16th Goal Kick", val: 16 }, { name: "17th Goal Kick", val: 17 },
        { name: "18th Goal Kick", val: 18 }, { name: "19th Goal Kick", val: 19 }, { name: "20th Goal Kick", val: 20 },
        { name: "21st Goal Kick", val: 21 }, { name: "22nd Goal Kick", val: 22 }, { name: "23rd Goal Kick", val: 23 },
        { name: "24th Goal Kick", val: 24 }, { name: "25th Goal Kick", val: 25 }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      team: [
        { "special_1": "1st Goal Kick", "group": "1st Goal Kick"}, { "special_1": "2nd Goal Kick", "group": "2nd Goal Kick"},
        { "special_1": "3rd Goal Kick", "group": "3rd Goal Kick"}, { "special_1": "4th Goal Kick", "group": "4th Goal Kick"}, { "special_1": "5th Goal Kick", "group": "5th Goal Kick"},
        { "special_1": "6th Goal Kick", "group": "6th Goal Kick"}, { "special_1": "7th Goal Kick", "group": "7th Goal Kick"}, { "special_1": "8th Goal Kick", "group": "8th Goal Kick"},
        { "special_1": "9th Goal Kick", "group": "9th Goal Kick"}, { "special_1": "10th Goal Kick", "group": "10th Goal Kick"}, { "special_1": "11th Goal Kick", "group": "11th Goal Kick"},
        { "special_1": "12th Goal Kick", "group": "12th Goal Kick"}, { "special_1": "13th Goal Kick", "group": "13th Goal Kick"}, { "special_1": "14th Goal Kick", "group": "14th Goal Kick"},
        { "special_1": "15th Goal Kick", "group": "15th Goal Kick"}, { "special_1": "16th Goal Kick", "group": "16th Goal Kick"}, { "special_1": "17th Goal Kick", "group": "17th Goal Kick"},
        { "special_1": "18th Goal Kick", "group": "18th Goal Kick"}, { "special_1": "19th Goal Kick", "group": "19th Goal Kick"}, { "special_1": "20th Goal Kick", "group": "20th Goal Kick"},
        { "special_1": "21st Goal Kick", "group": "21st Goal Kick"}, { "special_1": "22nd Goal Kick", "group": "22nd Goal Kick"}, { "special_1": "23rd Goal Kick", "group": "23rd Goal Kick"},
        { "special_1": "24th Goal Kick", "group": "24th Goal Kick"}, { "special_1": "25th Goal Kick", "group": "25th Goal Kick"}, { "special_1": "26th Goal Kick", "group": "26th Goal Kick"}
      ]
    },
    "NXT GK ET": {
      preferLeague: " - GOAL KICK",
      sboLeague: " - GOAL KICK",
      ibcLeague: " - GOAL KICK",
      style: 1,
      teamOpt: [
        { name: "1st Goal Kick", val: 1 }, { name: "2nd Goal Kick", val: 2 },
        { name: "3rd Goal Kick", val: 3 }, { name: "4th Goal Kick", val: 4 }, { name: "5th Goal Kick", val: 5 },
        { name: "6th Goal Kick", val: 6 }, { name: "7th Goal Kick", val: 7 }, { name: "8th Goal Kick", val: 8 },
        { name: "9th Goal Kick", val: 9 }, { name: "10th Goal Kick", val: 10 }, { name: "11th Goal Kick", val: 11 },
        { name: "12th Goal Kick", val: 12 }, { name: "13th Goal Kick", val: 13 }, { name: "14th Goal Kick", val: 14 },
        { name: "15th Goal Kick", val: 15 }, { name: "16th Goal Kick", val: 16 }, { name: "17th Goal Kick", val: 17 },
        { name: "18th Goal Kick", val: 18 }, { name: "19th Goal Kick", val: 19 }, { name: "20th Goal Kick", val: 20 },
        { name: "21st Goal Kick", val: 21 }, { name: "22nd Goal Kick", val: 22 }, { name: "23rd Goal Kick", val: 23 },
        { name: "24th Goal Kick", val: 24 }, { name: "25th Goal Kick", val: 25 }
      ],
      preferTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      sboTeam: [{ "home": "{home_team} (ET) {special_1}", "away": "{away_team} (ET) {special_1}" }],
      ibcTeam: [{ "home": "{home_team} {special_1} (ET)", "away": "{away_team} {special_1} (ET)" }],
      team: [
        { "special_1": "1st Goal Kick", "group": "1st Goal Kick"}, { "special_1": "2nd Goal Kick", "group": "2nd Goal Kick"},
        { "special_1": "3rd Goal Kick", "group": "3rd Goal Kick"}, { "special_1": "4th Goal Kick", "group": "4th Goal Kick"}, { "special_1": "5th Goal Kick", "group": "5th Goal Kick"},
        { "special_1": "6th Goal Kick", "group": "6th Goal Kick"}, { "special_1": "7th Goal Kick", "group": "7th Goal Kick"}, { "special_1": "8th Goal Kick", "group": "8th Goal Kick"},
        { "special_1": "9th Goal Kick", "group": "9th Goal Kick"}, { "special_1": "10th Goal Kick", "group": "10th Goal Kick"}, { "special_1": "11th Goal Kick", "group": "11th Goal Kick"},
        { "special_1": "12th Goal Kick", "group": "12th Goal Kick"}, { "special_1": "13th Goal Kick", "group": "13th Goal Kick"}, { "special_1": "14th Goal Kick", "group": "14th Goal Kick"},
        { "special_1": "15th Goal Kick", "group": "15th Goal Kick"}, { "special_1": "16th Goal Kick", "group": "16th Goal Kick"}, { "special_1": "17th Goal Kick", "group": "17th Goal Kick"},
        { "special_1": "18th Goal Kick", "group": "18th Goal Kick"}, { "special_1": "19th Goal Kick", "group": "19th Goal Kick"}, { "special_1": "20th Goal Kick", "group": "20th Goal Kick"},
        { "special_1": "21st Goal Kick", "group": "21st Goal Kick"}, { "special_1": "22nd Goal Kick", "group": "22nd Goal Kick"}, { "special_1": "23rd Goal Kick", "group": "23rd Goal Kick"},
        { "special_1": "24th Goal Kick", "group": "24th Goal Kick"}, { "special_1": "25th Goal Kick", "group": "25th Goal Kick"}, { "special_1": "26th Goal Kick", "group": "26th Goal Kick"}
      ]
    },
    "PEN": {
      preferLeague: " - PENALTY",
      sboLeague: " - PENALTY",
      ibcLeague: " - PENALTY",
      style: 1,
      teamOpt: [
        { name: "1st Penalty", val: 1 }, { name: "2nd Penalty", val: 2 },
        { name: "3rd Penalty", val: 3 }, { name: "4th Penalty", val: 4 }, { name: "5th Penalty", val: 5 }
      ],
      preferTeam: [{ "home": "{home_team} -vs- {away_team} {special_1}", "away": "{home_team} -vs- {away_team} {special_2}" }],
      sboTeam: [{ "home": "{home_team} -vs- {away_team} {special_1}", "away": "{home_team} -vs- {away_team} {special_2}" }],
      ibcTeam: [{ "home": "{home_team} -vs- {away_team} {special_1}", "away": "{home_team} -vs- {away_team} {special_2}" }],
      team: [
        { "special_1": "1st Penalty Awarded - Yes", "special_2": "1st Penalty Awarded - No", "group": "1st Penalty"},
        { "special_1": "1st Penalty To Score - Yes", "special_2": "1st Penalty To Score - No", "group": "1st Penalty"},
        { "special_1": "2nd Penalty Awarded - Yes", "special_2": "2nd Penalty Awarded - No", "group": "2nd Penalty"},
        { "special_1": "2nd Penalty To Score - Yes", "special_2": "2nd Penalty To Score - No", "group": "2nd Penalty"},
        { "special_1": "3rd Penalty Awarded - Yes", "special_2": "3rd Penalty Awarded - No", "group": "3rd Penalty"},
        { "special_1": "3rd Penalty To Score - Yes", "special_2": "3rd Penalty To Score - No", "group": "3rd Penalty"},
        { "special_1": "4th Penalty Awarded - Yes", "special_2": "4th Penalty Awarded - No", "group": "4th Penalty"},
        { "special_1": "4th Penalty To Score - Yes", "special_2": "4th Penalty To Score - No", "group": "4th Penalty"},
        { "special_1": "5th Penalty Awarded - Yes", "special_2": "5th Penalty Awarded - No", "group": "5th Penalty"},
        { "special_1": "5th Penalty To Score - Yes", "special_2": "5th Penalty To Score - No", "group": "5th Penalty"}
      ]
    },
    "PEN SO": {
      preferLeague: " - PENALTY SHOOT-OUT",
      sboLeague: " - PENALTY SHOOT-OUT",
      ibcLeague: " - PENALTY SHOOT-OUT",
      style: 2,
      teamOpt: [
        { name: "1st Penalty", val: 1 }, { name: "2nd Penalty", val: 2 },
        { name: "3rd Penalty", val: 3 }, { name: "4th Penalty", val: 4 }, { name: "5th Penalty", val: 5 },
        { name: "6th Penalty", val: 6 }, { name: "7th Penalty", val: 7 }, { name: "8th Penalty", val: 8 },
        { name: "9th Penalty", val: 9 }, { name: "10th Penalty", val: 10 }
      ],
      preferTeam: [
        { "home": "{home_team} {special_1}", "away": "{home_team} {special_2}" },
        { "home": "{away_team} {special_1}", "away": "{away_team} {special_2}" }
      ],
      sboTeam: [
        { "home": "{home_team} {special_1}", "away": "{home_team} {special_2}" },
        { "home": "{away_team} {special_1}", "away": "{away_team} {special_2}" }
      ],
      ibcTeam: [
        { "home": "{home_team} {special_1}", "away": "{home_team} {special_2}" },
        { "home": "{away_team} {special_1}", "away": "{away_team} {special_2}" }
      ],
      team: [
        { "special_1": "1st Penalty - Goal", "special_2": "1st Penalty - No Goal", "group": "1st Penalty"},
        { "special_1": "2nd Penalty - Goal", "special_2": "2nd Penalty - No Goal", "group": "2nd Penalty"},
        { "special_1": "3rd Penalty - Goal", "special_2": "3rd Penalty - No Goal", "group": "3rd Penalty"},
        { "special_1": "4th Penalty - Goal", "special_2": "4th Penalty - No Goal", "group": "4th Penalty"},
        { "special_1": "5th Penalty - Goal", "special_2": "5th Penalty - No Goal", "group": "5th Penalty"},
        { "special_1": "6th Penalty - Goal", "special_2": "6th Penalty - No Goal", "group": "6th Penalty"},
        { "special_1": "7th Penalty - Goal", "special_2": "7th Penalty - No Goal", "group": "7th Penalty"},
        { "special_1": "8th Penalty - Goal", "special_2": "8th Penalty - No Goal", "group": "8th Penalty"},
        { "special_1": "9th Penalty - Goal", "special_2": "9th Penalty - No Goal", "group": "9th Penalty"},
        { "special_1": "10th Penalty - Goal", "special_2": "10th Penalty - No Goal", "group": "10th Penalty"}
      ]
    },
    "ST TG": {
      preferLeague: " - SINGLE TEAM TOTAL GOAL",
      sboLeague: " - SINGLE TEAM TOTAL GOAL",
      ibcLeague: " - SINGLE TEAM TOTAL GOAL",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} (Over)", "special_2": "{home_team} (Under)", "group": "Home (Over & Under)"},
        { "special_1": "{away_team} (Over)", "special_2": "{away_team} (Under)", "group": "Away (Over & Under)"},
      ]
    },
    "ST OU": {
      preferLeague: " - SINGLE TEAM OVER/UNDER",
      sboLeague: " - SINGLE TEAM OVER/UNDER",
      ibcLeague: " - SINGLE TEAM OVER/UNDER",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Home (Over & Under)"},
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Away (Over & Under)"},
      ]
    },
    "ST ET OU": {
      preferLeague: " - SINGLE TEAM OVER/UNDER",
      sboLeague: " - SINGLE TEAM OVER/UNDER",
      ibcLeague: " - SINGLE TEAM OVER/UNDER",
      style: 1,
      teamOpt: [
        { name: "Home (Over & Under)" }, { name: "Away (Over & Under)" }
      ],
      preferTeam: [{ "home": "{special_1} (ET) - Over", "away": "{special_2} (ET) - Under" }],
      sboTeam: [{ "home": "{special_1} (ET) - Over", "away": "{special_2} (ET) - Under" }],
      ibcTeam: [{ "home": "{special_1} - Over (ET)", "away": "{special_2} - Under (ET)" }],
      team: [
        { "special_1": "{home_team}", "special_2": "{home_team}", "group": "Home (Over & Under)"},
        { "special_1": "{away_team}", "special_2": "{away_team}", "group": "Away (Over & Under)"},
      ]
    },
    "1ST QRT": {
      preferLeague: " - 1st Quarter",
      sboLeague: " - 1st Quarter",
      // ibcLeague: " - Quarter 1 - HDP / O/U / O/E / Moneyline",
      ibcLeague: " - 1st Quarter",
      teamOpt: []
    },
    "2ND QRT": {
      preferLeague: " - 2nd Quarter",
      sboLeague: " - 2nd Quarter",
      // ibcLeague: " - Quarter 2 - HDP / O/U / O/E / Moneyline",
      ibcLeague: " - 2nd Quarter",
      teamOpt: []
    },
    "3RD QRT": {
      preferLeague: " - 3rd Quarter",
      sboLeague: " - 3rd Quarter",
      // ibcLeague: " - Quarter 3 - HDP / O/U / O/E / Moneyline",
      ibcLeague: " - 3rd Quarter",
      teamOpt: []
    },
    "4TH QRT": {
      preferLeague: " - 4th Quarter",
      sboLeague: " - 4th Quarter",
      // ibcLeague: " - Quarter 4 - HDP / O/U / O/E / Moneyline",
      ibcLeague: " - 4th Quarter",
      teamOpt: []
    },
    "HT TP": {
      preferLeague: " - Home Team Total Points",
      sboLeague: " - Home Team Total Points",
      ibcLeague: " - Home Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Over & Under"}
      ]
    },
    "AT TP": {
      preferLeague: " - Away Team Total Points",
      sboLeague: " - Away Team Total Points",
      ibcLeague: " - Away Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Over & Under"}
      ]
    },
    "FH HT TP": {
      preferLeague: " - First Half Home Team Total Points",
      sboLeague: " - First Half Home Team Total Points",
      ibcLeague: " - First Half Home Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Over & Under"}
      ]
    },
    "FH AT TP": {
      preferLeague: " - First Half Away Team Total Points",
      sboLeague: " - First Half Away Team Total Points",
      ibcLeague: " - First Half Away Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Over & Under"}
      ]
    },
    "1ST QRT HT TP": {
      preferLeague: " - 1st Quarter Home Team Total Points",
      sboLeague: " - 1st Quarter Home Team Total Points",
      ibcLeague: " - 1st Quarter Home Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Over & Under"}
      ]
    },
    "1ST QRT AT TP": {
      preferLeague: " - 1st Quarter Away Team Total Points",
      sboLeague: " - 1st Quarter Away Team Total Points",
      ibcLeague: " - 1st Quarter Away Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Over & Under"}
      ]
    },
    "2ND QRT HT TP": {
      preferLeague: " - 2nd Quarter Home Team Total Points",
      sboLeague: " - 2nd Quarter Home Team Total Points",
      ibcLeague: " - 2nd Quarter Home Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Over & Under"}
      ]
    },
    "2ND QRT AT TP": {
      preferLeague: " - 2nd Quarter Away Team Total Points",
      sboLeague: " - 2nd Quarter Away Team Total Points",
      ibcLeague: " - 2nd Quarter Away Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Over & Under"}
      ]
    },
    "3RD QRT HT TP": {
      preferLeague: " - 3rd Quarter Home Team Total Points",
      sboLeague: " - 3rd Quarter Home Team Total Points",
      ibcLeague: " - 3rd Quarter Home Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Over & Under"}
      ]
    },
    "3RD QRT AT TP": {
      preferLeague: " - 3rd Quarter Away Team Total Points",
      sboLeague: " - 3rd Quarter Away Team Total Points",
      ibcLeague: " - 3rd Quarter Away Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Over & Under"}
      ]
    },
    "4TH QRT HT TP": {
      preferLeague: " - 4th Quarter Home Team Total Points",
      sboLeague: " - 4th Quarter Home Team Total Points",
      ibcLeague: " - 4th Quarter Home Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{home_team} - Over", "special_2": "{home_team} - Under", "group": "Over & Under"}
      ]
    },
    "4TH QRT AT TP": {
      preferLeague: " - 4th Quarter Away Team Total Points",
      sboLeague: " - 4th Quarter Away Team Total Points",
      ibcLeague: " - 4th Quarter Away Team Total Points",
      style: 1,
      teamOpt: [
        { name: "Over & Under" }
      ],
      preferTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      sboTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      ibcTeam: [{ "home": "{special_1}", "away": "{special_2}" }],
      team: [
        { "special_1": "{away_team} - Over", "special_2": "{away_team} - Under", "group": "Over & Under"}
      ]
    },
    "NXT GL IH": {
      preferLeague: " - NEXT GOAL",
      sboLeague: " - NEXT GOAL",
      ibcLeague: " - NEXT GOAL",
      rpLeagueWord: " - Regular Time Only",
      style: 1,
      teamOpt: [
        { name: "1st Goal", val: 1 }, { name: "2nd Goal", val: 2 },
        { name: "3rd Goal", val: 3 }, { name: "4th Goal", val: 4 }, { name: "5th Goal", val: 5 },
        { name: "6th Goal", val: 6 }, { name: "7th Goal", val: 7 }, { name: "8th Goal", val: 8 },
        { name: "9th Goal", val: 9 }, { name: "10th Goal", val: 10 }, { name: "11th Goal", val: 11 },
        { name: "12th Goal", val: 12 }, { name: "13th Goal", val: 13 }, { name: "14th Goal", val: 14 },
        { name: "15th Goal", val: 15 }, { name: "16th Goal", val: 16 }, { name: "17th Goal", val: 17 },
        { name: "18th Goal", val: 18 }, { name: "19th Goal", val: 19 }, { name: "20th Goal", val: 20 }
      ],
      preferTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      sboTeam: [{ "home": "{home_team} {special_1}", "away": "{away_team} {special_1}" }],
      ibcTeam: [{ "home": "{home_team} ({special_1})", "away": "{away_team} ({special_1})" }],
      team: [
        { "special_1": "1st Goal", "group": "1st Goal"}, { "special_1": "2nd Goal", "group": "2nd Goal"},
        { "special_1": "3rd Goal", "group": "3rd Goal"}, { "special_1": "4th Goal", "group": "4th Goal"}, { "special_1": "5th Goal", "group": "5th Goal"},
        { "special_1": "6th Goal", "group": "6th Goal"}, { "special_1": "7th Goal", "group": "7th Goal"}, { "special_1": "8th Goal", "group": "8th Goal"},
        { "special_1": "9th Goal", "group": "9th Goal"}, { "special_1": "10th Goal", "group": "10th Goal"},
        { "special_1": "11th Goal", "group": "11th Goal"}, { "special_1": "12th Goal", "group": "12th Goal"}, { "special_1": "13th Goal", "group": "13th Goal"},
        { "special_1": "14th Goal", "group": "14th Goal"}, { "special_1": "15th Goal", "group": "15th Goal"}, { "special_1": "16th Goal", "group": "16th Goal"},
        { "special_1": "17th Goal", "group": "17th Goal"}, { "special_1": "18th Goal", "group": "18th Goal"}, { "special_1": "19th Goal", "group": "19th Goal"},
        { "special_1": "20th Goal", "group": "20th Goal"}
      ],
    },
  }
}